import React from "react";
import { Form, Radio, Input, Space, Row } from "antd";
interface props {
  activeQuestion: any;
}

const SingleSelectOptions: React.FC<props> = (props) => {
  const { activeQuestion } = props;

  return (
    <div className="answer-input-wrapper">
      <Form.Item
        className="questionlist-radio"
        name={activeQuestion?.data?.question}
        rules={[
          { required: true, message: "You have to select alteast one option" },
        ]}
      >
        <Radio.Group>
          <Space direction="vertical">
            {activeQuestion?.options.map((option: any, index: any) => {
              return (
                <Radio
                  value={typeof option === "string" ? option : option.label}
                  key={index}
                  className="custom-label-text"
                >
                  {typeof option === "string" ? option : option.label}
                  {activeQuestion?.subTextOptions?.length ? (
                    <Row className="questionlist-radio__subtext">
                      {activeQuestion?.subTextOptions[index]}
                    </Row>
                  ) : (
                    <></>
                  )}
                </Radio>
              );
            })}
          </Space>
        </Radio.Group>
      </Form.Item>
    </div>
  );
};

export default SingleSelectOptions;
